export default class StoreOps {
  public static FILIALE_SELECT = "filialeSelect"
  public static FILIALE_SELECT_MEMBER = "filialeSelectMember"
  public static POST_INCOMING_MESSAGE = "postIncomingMessage"
  public static UPDATE_IDENTIFIER = "updateIdentifier"
  public static LOGIN_MEMBER = "loginMember"
  public static LOGIN_KUNDE = "loginKunde"
  public static LOGOUT = "logout"
}
